import { GUSInformationDTO } from 'types';

export const parseGUSStreetDataIntoStreetFormField: (
    gusData: Pick<GUSInformationDTO, 'street' | 'buildingNumber' | 'premisesNumber'>,
) => string = (gusData) => {
    const { street, buildingNumber, premisesNumber } = gusData;

    return `${street} ${buildingNumber}${premisesNumber ? `/${premisesNumber}` : ''}`;
};
